import { TextField } from '@/components/form/fields/text/TextInput';
import { usePoClearDeliveryAddressId, usePoDelivery } from '@/services/purchaseOrders/usePurchaseOrderService';
import { FunctionComponent } from 'react';

interface AddressFieldProps {
  fieldKey?: string;
  readonly?: boolean;
  optional?: boolean;
}

const AddressField: FunctionComponent<AddressFieldProps> = ({ fieldKey = '', readonly, optional = false }) => {
  const fieldPrefix = fieldKey ? `${fieldKey}.` : '';
  const delivery = usePoDelivery();
  const clearDeliveryAddressId = usePoClearDeliveryAddressId();

  const handleManualEdit = () => {
    if (delivery?.addressId) {
      clearDeliveryAddressId();
    }
  };

  return (
    <div className="flex flex-col space-y-1">
      <TextField
        readonly={readonly}
        id={`${fieldPrefix}address.addressLine1`}
        label="Address Line 1"
        example="Example: 7 Main Street"
        optional={optional}
        onChangeCallback={handleManualEdit}
      />
      <TextField
        readonly={readonly}
        id={`${fieldPrefix}address.addressLine2`}
        label="Address Line 2"
        optional
        example="Example: Building 4"
        onChangeCallback={handleManualEdit}
      />
      <div className="flex flex-row space-x-5">
        <TextField
          readonly={readonly}
          className="flex-1"
          id={`${fieldPrefix}address.townCity`}
          label="Town/City"
          optional={optional}
          onChangeCallback={handleManualEdit}
        />
        <TextField
          readonly={readonly}
          className="flex-1"
          id={`${fieldPrefix}address.stateCounty`}
          label="State/County"
          optional={optional}
          onChangeCallback={handleManualEdit}
        />
      </div>
      <div className="flex flex-row space-x-5">
        <TextField
          readonly={readonly}
          className="flex-1"
          id={`${fieldPrefix}address.postalCode`}
          label="Postal/Zip Code"
          optional={optional}
          onChangeCallback={handleManualEdit}
        />
        <TextField
          readonly={readonly}
          className="flex-1"
          id={`${fieldPrefix}address.country`}
          label="Country"
          optional={optional}
          onChangeCallback={handleManualEdit}
        />
      </div>
    </div>
  );
};

export default AddressField;
